import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Spin, Typography } from "antd";
import { getTransactionsStatusId } from "features/transactions-status";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ROUTES from "shared/routes";
import { MainLayout } from "widgets/main-layout";
import styles from "./index.module.scss";

export const TransactionsStatusPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { transactionsId } = useParams();
  const shouldRefetch = useRef(true);

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["transactions", transactionsId],
    queryFn: () => getTransactionsStatusId(transactionsId!),
    enabled: !!transactionsId,
    refetchInterval: (query) => {
      const state = query.state.data;

      if (
        query.state.status === "error" ||
        (state && state.status?.type !== "LOADING")
      ) {
        shouldRefetch.current = false;
        return false;
      }

      return shouldRefetch.current ? 2000 : false;
    },
  });
  if (isLoading) {
    return (
      <div className={styles.wrapperLoader}>
        <Spin />
      </div>
    );
  }
  if (!data || isError) {
    return (
      <div className={styles.wrapperLoader}>
        <Typography.Title level={3}>
          {t("transaction.error_title")}
        </Typography.Title>
        <Typography.Text
          style={{
            fontSize: 16,
            marginBottom: 24,
            display: "block",
            color: "var(--color-grey)",
            textAlign: "center",
          }}
        >
          {(error as any)?.response?.data?.message ||
            t("transaction.error_message")}
        </Typography.Text>
        <Button
          block
          onClick={() => {
            navigate(ROUTES.MAIN);
          }}
        >
          {t("transaction.go_to_main")}
        </Button>
      </div>
    );
  }
  return (
    <MainLayout withoutToolbar>
      <div style={{ paddingTop: "15vh" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 24,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 52,
              height: 52,
              borderRadius: "50%",
              fontSize: 26,
              ...(data.status?.type
                ? {
                    LOADING: {
                      color: "var(--ant-blue)",
                      backgroundColor: "var(--ant-blue-2)",
                    },
                    SUCCESS: {
                      color: "var(--ant-green)",
                      backgroundColor: "var(--ant-green-2)",
                    },
                    FAIL: {
                      color: "var(--ant-red)",
                      backgroundColor: "var(--ant-red-2)",
                    },
                  }[data.status.type]
                : {}),
            }}
          >
            {data.status?.type &&
              {
                LOADING: <LoadingOutlined />,
                SUCCESS: <CheckCircleOutlined />,
                FAIL: <CloseCircleOutlined />,
              }[data.status.type]}
          </div>
          <Typography.Title level={2} style={{ textAlign: "center" }}>
            {data.status?.type &&
              {
                LOADING: t("transaction.status_loading"),
                SUCCESS: t("transaction.status_success"),
                FAIL: t("transaction.status_error"),
              }[data.status.type]}
          </Typography.Title>
          <Button
            block
            onClick={() => {
              navigate(ROUTES.MAIN);
            }}
          >
            {t("transaction.go_to_main")}
          </Button>
        </div>
      </div>
    </MainLayout>
  );
};
